import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
} from "./model-utils";
import { enumValue, MemberStatus, MemberType, RequestType } from "./enums";

export class Member {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.memberId = asString(json.memberId);
    this.orgId = asString(json.orgId);
    this.orgReadId = asString(json.orgReadId);
    this.orgName = asString(json.orgName);
    this.orgLogo = asString(json.orgLogo);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.userId = asString(json.userId);
    this.firstName = asString(json.firstName);
    this.lastName = asString(json.lastName);
    this.name =
      asString(json.name) ||
      [this.firstName, this.lastName].filter(Boolean).join(" ");
    this.email = asString(json.email);
    this.bio = asString(json.bio);
    this.intCode = asString(json.intCode);
    this.phone = asString(json.phone);
    this.fullPhone = asString(json.fullPhone);
    this.address = asString(json.address);
    this.designation = asString(json.designation);
    this.dateOfJoin = asDate(json.dateOfJoin);
    this.createdAt = asDate(json.createdAt);
    this.updatedAt = asDate(json.updatedAt);
    this.imageUrl = asString(json.imageUrl);
    this.status = enumValue(MemberStatus, json.status);
    this.requestType = enumValue(RequestType, json.requestType);
    this.memberType = enumValue(MemberType, json.memberType);
    this.membershipNo = asString(json.membershipNo);
    this.admin = asBoolean(json.admin);
    this.deactivated = asBoolean(json.deactivated);
    this.owner = asBoolean(json.owner);
    this.enableAccess = asBoolean(json.enableAccess);
    this.enableIdentityCard = asBoolean(json.enableIdentityCard);
    this.userName = asString(json.userName);
    this.canLeave = asBoolean(json.canLeave);
    this.oneTimeRegistration = asBoolean(json.oneTimeRegistration);
    this.verified = asBoolean(json.verified);
    this.identityActivated = asBoolean(json.identityActivated);
    this.identityUrl = asString(json.identityUrl);
    this.paidAdmin = asBoolean(json.paidAdmin) ?? false;
    this.setUpIdentity = asBoolean(json.setUpIdentity);
    this.dependant = asBoolean(json.dependant);
    this.dependantLinkUpId = asString(json.dependantLinkUpId);
    this.excludeOneTimeRegistration = asBoolean(
      json.excludeOneTimeRegistration,
    );
    this.dependantRelationship = asString(json.dependantRelationship);
    this.setPin = asBoolean(json.setPin);
    this.pinHashDate = asDate(json.pinHashDate);
    this.sendInvite = asBoolean(json.sendInvite);
    this.userLinked = asBoolean(json.userLinked) ?? false;
    this.executiveMember = asBoolean(json.executiveMember);
    this.dateOfExit = asDate(json.dateOfExit);
    this.maximumDependant = asNumber(json.maximumDependant);
    this.allowOrderCreation = asBoolean(json.allowOrderCreation);
    this.permissions = Array.isArray(json.permissions)
      ? json.permissions.map(String)
      : undefined;
  }

  static fromJson(json: any) {
    return isObject(json) ? new Member(json) : json;
  }
}
